import { motion } from "framer-motion";
import { MessageCircle, Mail, Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

const CHANNELS = [
  { icon: MessageCircle, label: "WhatsApp", value: CONTACT.whatsappLabel, href: CONTACT.whatsapp, testid: "contact-whatsapp" },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "contact-email" },
  { icon: Instagram, label: "Instagram", value: CONTACT.instagramLabel, href: CONTACT.instagram, testid: "contact-instagram" },
];

export const Contact = () => {
  return (
    <section
      id="cierre"
      data-testid="contact-section"
      className="relative bg-mango text-ink overflow-hidden pt-24 md:pt-36 pb-10"
    >
      <div className="noise-overlay absolute inset-0 opacity-[0.06] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <p className="text-xs font-bold tracking-[0.25em] uppercase mb-6">
          Hablemos de tu marca
        </p>
        <h2 className="font-display font-black text-5xl sm:text-7xl lg:text-[8rem] tracking-tighter leading-[0.85]">
          ¿Lista para<br />
          <span className="italic font-clash">surfear</span> la ola?
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-4">
          {CHANNELS.map((c) => (
            <motion.a
              key={c.label}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={c.testid}
              aria-label={c.label}
              whileHover={{ y: -6 }}
              className="group flex items-center justify-between rounded-3xl bg-ink text-cream p-7 md:p-8"
            >
              <div className="flex items-center gap-4">
                <span className="grid place-items-center h-12 w-12 rounded-2xl bg-mango text-ink">
                  <c.icon size={22} />
                </span>
                <div>
                  <p className="text-cream/50 text-xs uppercase tracking-widest">{c.label}</p>
                  <p className="font-semibold text-base">{c.value}</p>
                </div>
              </div>
              <ArrowUpRight className="text-mango group-hover:rotate-45 transition-transform duration-300" size={24} />
            </motion.a>
          ))}
        </div>

        <div className="mt-24 pt-8 border-t border-ink/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <button onClick={() => scrollToId("#top")} className="font-display text-3xl md:text-4xl font-black tracking-tighter lowercase text-left">
            isavicente<span className="text-green">.</span>
          </button>
          <div className="flex items-center gap-5">
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="hover:opacity-60 transition-opacity">
              <Instagram size={22} />
            </a>
            <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin" className="hover:opacity-60 transition-opacity">
              <Linkedin size={22} />
            </a>
            <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp" className="hover:opacity-60 transition-opacity">
              <MessageCircle size={22} />
            </a>
          </div>
          <p className="text-ink/60 text-sm">
            © {new Date().getFullYear()} isavicente · Community & Marketing
          </p>
        </div>
      </div>
    </section>
  );
};
